import { authHeader } from '@/services/auth'
import axios from 'axios'
import { formatCodenamesCall } from '@/services/posts'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

const baseURL = processEnvConfig.VUE_APP_HYPER_ESPACE_API_URL + '/social-management-posts'

export default {
  namespaced: true,
  state: {
    socialPostsBiensVendus: {
      total: -1,
      list: []
    },
    filters: {
      page: 1,
      limit: 10,
      search: '',
      network: null,
      dateDiff: {
        before: null,
        after: null
      }
    },
    loadingStatus: false,
    modalDelete: false,
    postToDelete: []
  },
  getters: {
    getSocialPostsBienVendus: (state) => state.socialPostsBiensVendus,
    getPage: (state) => state.filters.page,
    getLimit: (state) => state.filters.limit,
    getSearch: (state) => state.filters.search,
    getLoadingStatus: (state) => state.loadingStatus,
    getNetwork: (state) => state.filters.network,
    getModalDelete: (state) => state.modalDelete,
    getPostToDelete: (state) => state.postToDelete,
    getIdsToDelete: (state) => state.idsToDelete
  },
  mutations: {
    setSocialPostsBiensVendus (state, payload) {
      state.socialPostsBiensVendus = payload
    },
    setPage (state, payload) {
      state.filters.page = payload
    },
    setLimit (state, payload) {
      state.filters.limit = payload
    },
    setLoadingStatus (state, payload) {
      state.loadingStatus = payload
    },
    setSearch (state, payload) {
      state.filters.search = payload
    },
    setDateDiff (state, dateDiff) {
      state.filters.dateDiff = dateDiff
    },
    setModalDelete (state, modalDelete) {
      state.modalDelete = modalDelete
    },
    setPostToDelete (state, postToDelete) {
      state.postToDelete = postToDelete
    },
    checkDiffusionsPostsToDelete (state) {
      const posts = []
      state.postToDelete.forEach(function (post) {
        let cpt = 0
        post.diffusions.forEach(function (diffusion) {
          if (diffusion.firstSentAt) {
            cpt = cpt + 1
          }
        })
        if (cpt === 0) {
          posts.push(post)
        }
      })
      state.postToDelete = posts
    },
    setNetwork (state, payload) {
      if (payload === 'allPosts') {
        state.filters.network = null
      } else {
        state.filters.network = payload
      }
    }
  },
  actions: {
    loadSocialPostsBiensVendus ({ commit, getters }) {
      commit('setLoadingStatus', true)
      const params = {
        headers: authHeader()
      }
      let url = `${baseURL}?etat=V`
      url = url + '&fields=reference,etat,titre,photoPrincipale'
      url = url + '&champsRechercheLibre[]=ville&champsRechercheLibre[]=titre&champsRechercheLibre[]=reference'
      url = url + '&rechercheLibre=' + getters.getSearch
      const codenamesCall = formatCodenamesCall(true, true)
      let codenames = ''
      if (codenamesCall !== undefined && codenamesCall.length > 0 && codenamesCall[0]) {
        codenames = codenamesCall[0]
      }
      if (getters.getNetwork != null && getters.getNetwork !== 'allPosts') {
        codenames = getters.getNetwork
      }
      url = url + '&portalCodesAnnonces=' + codenames
      if (codenamesCall !== undefined && codenamesCall.length > 0 && codenamesCall[1]) {
        codenamesCall[1].forEach(function (element) {
          url = url + '&linkedPortals[]=' + element
        })
      }
      if (getters.getNetwork != null && getters.getNetwork !== 'allPosts') {
        url = url + '&annoncesDiffusees=O'
      }
      url = url + '&page=' + getters.getPage
      url = url + '&perPage=' + getters.getLimit

      // Filters => voir pour ajouter les filtres en fonction des datas envoyé
      return axios.get(url, params)
        .then(response => {
          if (response.data.annonces) {
            const objResponse = {
              total: response.data.total,
              list: response.data.annonces
            }
            commit('setSocialPostsBiensVendus', objResponse)
            commit('setLoadingStatus', false)
          }
        }).catch(error => {
          console.log({ type: 'error', message: error })
          commit('setLoadingStatus', false)
        })
    },
    deletePostBienvendu (context) {
      context.commit('setLoadingStatus', true)

      const posts = context.getters.getPostToDelete
      const params = {
        data: posts
      }
      const url = '/annonce'
      const deletePost = HTTP_HYPER_ESPACE_BACKEND
        .delete(url, params)
        .then(response => {
          return { type: 'success', message: 'OK' }
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
        .finally(function () {
          context.dispatch('loadSocialPostsEditoriaux')
          context.commit('setLoadingStatus', false)
          context.commit('setModalDelete', false)
        })
    }
  }
}
